export const columnWidth = {
  APPLICATION_NAME: 250,
  APPLICATION_CATEGORY: 150,
  DEPARTMENT_NAME: 200,
  PROJECT_NAME: 200,
  DATE: 200,
  COUNT: 150,
  COST: 150,
  USER_NAME: 250,
  DESIGNATION: 200,
  EMAIL: 300,
  RELATIVE_TIME: 200,
  LICENSE_NAME: 200,
  GENERAL: 150,
  COUNTLESS: 95,
};
